import {
  arrayBufferFileLoader,
  type DocRenderer,
} from "@cyntler/react-doc-viewer";
import { useEffect, useState } from "react";

export const PDFRenderer: DocRenderer = ({
  mainState: { currentDocument },
}) => {
  const [url, setUrl] = useState("");
  const fileData = currentDocument?.fileData;

  useEffect(() => {
    if (!(fileData instanceof ArrayBuffer)) return;

    const blob = new Blob([fileData], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    setUrl(url);

    return () => {
      URL.revokeObjectURL(url);
    };
  }, [fileData]);

  if (!currentDocument) return null;

  return (
    <div className="w-full h-full min-h-[60vh] relative">
      {url && <iframe src={url} className="w-full h-full absolute" />}
    </div>
  );
};
PDFRenderer.fileTypes = ["pdf", "application/pdf"];
PDFRenderer.weight = 1;
PDFRenderer.fileLoader = arrayBufferFileLoader;
